<template>
  <Card title="absences.setting.set_absence_type_config" containerClass="mb-5 shadow-sm">
    <template #cardBody>
      <h2>{{$t('absences.setting.informations')}} {{absenceTypeConfig?.holiday_type?.name ? '('+absenceTypeConfig?.holiday_type?.name+')' : ''}}</h2>

      <div class="bg-light-warning text-warning border-rounded mt-5 px-10 py-7 d-flex align-items-center fs-5 fw-bold" style="border-radius: 5px;">
        <i class="fas fa-exclamation-circle me-3 fs-2 text-warning"></i> 
        {{ $t('absences.setting.select_types') }}
      </div>

      <div class="row mt-5">
        <div class="col-12 col-md-7 col-lg-7">
          <Select2
            container-class="form-group mt-5"
            :multiple="false"
            :show-search="true"
            :selectClass="'form-select form-control-sm form-select-solid'"
            name="type_absence"
            :label="$t('absences.type_absence')"
            labelClass="form-label fs-6 text-black"
            :placeholder-text="$t('absences.type_absence')"
            v-model="formTypeData.holiday_type_id"
            :isRequired="false"
            :IsInputGroup="true"
            icon="bi bi-plus"
            :clickAddon="openCreateModal" 
            >
            <option v-for="absenceType in absenceTypes" :value="absenceType.id" :key="absenceType.id">
              {{ absenceType.name }}
            </option>
          </Select2>
        </div>
        <div class="col-12 col-md-5 col-lg-5 mt-5">
          <div class="d-flex flex-column">
            <label class="form-label fs-6 text-black">
              {{$t('absences.setting.color')}}
            </label>
            <div 
              class="p-1 d-flex align-items-center"
              :style="{ backgroundColor: formTypeData.color, width: '60%', borderRadius: '10px' }"
            >
              <ColorPicker 
                v-model:pureColor="formTypeData.color" 
                format="hex"
                :style="{ borderRadius: '10px', width: '60%' }"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-8">
        <div class="col-md-12">
          <div class="d-flex flex-column mb-8">
            <label class="form-label fs-6 text-black">{{$t('absences.setting.description')}}</label>
            <textarea class="form-control form-control-solid" rows="3" :name="'description'+id" v-model="formTypeData.description" :placeholder="$t('absences.setting.description')"></textarea>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-md-6 col-lg-6">
          <Card containerClass="mb-5 shadow-sm" bodyClass="py-3" titleContainerClass="d-flex justify-content-center">
            <template #cardBody>
              <div class="d-flex justify-content-between align-items-center">
                <span class="fs-3 fw-bold">{{$t('absences.setting.paid_absence')}}</span>

                <div class="form-check form-switch form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" v-model="formTypeData.paid" id="flexSwitchDefault1"/>
                </div>
              </div>
            </template>
          </Card>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <Card containerClass="mb-5 shadow-sm" bodyClass="py-3" titleContainerClass="d-flex justify-content-center">
            <template #cardBody>
              <div class="d-flex justify-content-between align-items-center">
                <span class="fs-3 fw-bold">{{$t('absences.setting.need_to_add_file')}}</span>

                <div class="form-check form-switch form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" v-model="formTypeData.attachment" id="flexSwitchDefault2"/>
                </div>
              </div>
            </template>
          </Card>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 col-md-6 col-lg-6">
          <Card containerClass="mb-5 shadow-sm" bodyClass="py-3" titleContainerClass="d-flex justify-content-center">
            <template #cardBody>
              <div class="d-flex justify-content-between align-items-center">
                <span class="fs-3 fw-bold">{{$t('absences.setting.no_public_holiday')}}</span>

                <div class="form-check form-switch form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" v-model="formTypeData.include_day_off" id="flexSwitchDefault3"/>
                </div>
              </div>
            </template>
          </Card>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <Card containerClass="mb-5 shadow-sm" bodyClass="py-3" titleContainerClass="d-flex justify-content-center">
            <template #cardBody>
              <div class="d-flex justify-content-between align-items-center">
                <span class="fs-3 fw-bold">{{$t('absences.setting.start_by_previous_date')}}</span>

                <div class="form-check form-switch form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" v-model="formTypeData.allow_previous_date" id="flexSwitchDefault4"/>
                </div>
              </div>
            </template>
          </Card>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 col-md-6 col-lg-6">
          <div class="form-check">
              <input class="form-check-input mt-1" type="checkbox" v-model="formTypeData.seniority" id="flexCheckDefault" />
              <label class="form-check-label fs-3 fw-bold">
                  {{$t('absences.setting.min_seniority')}}
              </label>
          </div>
        </div>
      </div>

      <div v-if="formTypeData.seniority" class="row ms-7 mt-5">
        <div class="col-12 col-md-6 col-lg-6">
          <div class="row mb-3">
            <div class="col-12 col-md-7 col-lg-7">
               <VueNumberFormat v-model:value="formTypeData.min_seniority" class="form-control form-control-solid" :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
                ></VueNumberFormat>
            </div>
            <div class="col-12 col-md-4 col-lg-4">
               <Select2
                container-class="form-group"
                :multiple="false"
                :show-search="false"
                :selectClass="'form-select form-control-sm form-select-solid'"
                name="periode"
                :placeholder-text="$t('absences.periode')"
                v-model="formTypeData.periode"
                :isRequired="false" 
                >
                <option value="days">{{$t('absences.setting.days')}}</option>
                <option value="months">{{$t('absences.setting.months')}}</option>
                <option value="years">{{$t('absences.setting.years')}}</option>
              </Select2>
            </div>
          </div>
          <span class="fs-3 text-muted" v-html="$t('absences.setting.enter_min_seniority')"></span>
        </div>
      </div>

      <div class="mb-8">
        <div class="row mt-8">
          <div class="col-12 col-md-6 col-lg-6">
            <div class="form-check">
                <input class="form-check-input mt-1" type="checkbox" v-model="formTypeData.have_stock" id="flexCheckDefault1" />
                <label class="form-check-label fs-3 fw-bold" for="flexCheckDefault1">
                    {{$t('absences.setting.have_stock')}}
                </label>
            </div>
          </div>
        </div>

        <div v-if="formTypeData.have_stock" class="row ms-5 mt-5">
          <div class="col-12 col-md-6 col-lg-6">
            <p class="fs-2 fw-bold">{{$t('absences.setting.stock_is')}}</p>
            <div class="row my-5">
              <div :class="formTypeData.cummulable == 'cummulable' ? 'col-12 col-md-4 col-lg-4' : 'col-12 col-md-7 col-lg-7'">
                <div class="form-check">
                  <input class="form-check-input mt-1" type="radio" value="fixed" v-model="formTypeData.cummulable" id="flexCheckDefault3" />
                  <label class="form-check-label fs-3 fw-bold">
                      {{$t('absences.setting.fixed')}}
                  </label>
                </div>
                <input v-model="formTypeData.stock" class="form-control form-control-solid mt-5"/>
              </div>
              <div :class="formTypeData.cummulable == 'cummulable' ? 'col-12 col-md-8 col-lg-8' : 'col-12 col-md-4 col-lg-4'">
                <div class="form-check">
                  <input class="form-check-input mt-1" type="radio" value="cummulable" v-model="formTypeData.cummulable" id="flexCheckDefault3" />
                  <label class="form-check-label fs-3 fw-bold">
                      {{$t('absences.setting.cummulable')}}
                  </label>
                </div>
                <div class="row">
                  <Select2
                    :container-class="formTypeData.cummulable == 'cummulable' ? 'form-group mt-5 col-12 col-md-5 col-lg-5' : 'form-group mt-5 col-12 col-md-12 col-lg-12'"
                    :multiple="false"
                    :show-search="false"
                    :selectClass="'form-select form-control-sm form-select-solid'"
                    name="stock_periode"
                    :placeholder-text="$t('absences.periode')"
                    v-model="formTypeData.stock_periode"
                    :isRequired="false" 
                    >
                    <option value="days">{{$t('absences.setting.days')}}</option>
                    <option value="months">{{$t('absences.setting.months')}}</option>
                    <option value="years">{{$t('absences.setting.years')}}</option>
                  </Select2>
                  <span v-if="formTypeData.cummulable == 'cummulable'" style="margin-right: -7px; margin-left: -7px;" :class="formTypeData.cummulable == 'cummulable' ? 'col-12 col-md-2 col-lg-2 text-center mt-8' : ''">{{$t('absences.setting.by')}}</span>
                  <Select2
                    v-if="formTypeData.cummulable == 'cummulable'"
                    :container-class="formTypeData.cummulable == 'cummulable' ? 'form-group mt-5 col-12 col-md-5 col-lg-5' : 'form-group mt-5'"
                    :multiple="false"
                    :show-search="false"
                    :selectClass="'form-select form-control-sm form-select-solid'"
                    name="cummulabe_periode"
                    :placeholder-text="$t('absences.periode')"
                    v-model="formTypeData.cummulabe_periode"
                    :isRequired="false" 
                    >
                    <option value="months">{{$t('absences.setting.months')}}</option>
                    <option value="years">{{$t('absences.setting.years')}}</option>
                  </Select2>
                </div>
              </div>
            </div>
            <span class="fs-3 text-muted" v-html="$t('absences.setting.stock_give_absence')"></span>
          </div>

          <div class="col-12 col-md-6 col-lg-6 mt-10" v-if="formTypeData.cummulable == 'cummulable'">
            <Card containerClass="mb-5 shadow-sm" bodyClass="py-3" titleContainerClass="d-flex justify-content-center">
              <template #cardBody>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="fs-3 fw-bold" v-html="$t('absences.setting.reinitialable')"></span>

                  <div class="form-check form-switch form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" v-model="formTypeData.reinitialable" id="flexSwitchDefault5"/>
                  </div>
                </div>
              </template>
            </Card>

            <Card containerClass="shadow-sm" bodyClass="py-3" titleContainerClass="d-flex justify-content-center">
              <template #cardBody>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="fs-3 fw-bold">{{$t('absences.setting.take_all_without_count')}}</span>

                  <div class="form-check form-switch form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" v-model="formTypeData.take_all_without_count" id="flexSwitchDefault6"/>
                  </div>
                </div>
              </template>
            </Card>
          </div>
        </div>
      </div>

      <div style="border-top: 1px solid #e0e0e0;" v-if="formTypeData.have_stock">
        <div class="ms-7 mt-5">
          <p class="fs-2 fw-bold">{{$t('absences.setting.take_stock')}} :</p>
          <div class="row mt-5">
            <div class="col-12 col-md-4 col-lg-4">
              <div class="form-check mb-5">
                <input class="form-check-input mt-1" type="radio" value="PARTIALLY" v-model="formTypeData.type_under_stock" id="flexCheckDefault4" />
                <label class="form-check-label fs-3 fw-bold" for="flexCheckDefault4">
                    {{$t('absences.setting.partially')}}
                </label>
              </div>
              <span class="fs-3 text-muted" v-html="$t('absences.setting.partially_text')"></span>
            </div>
            <div class="col-12 col-md-4 col-lg-4">
              <div class="form-check mb-5">
                <input class="form-check-input mt-1" type="radio" value="TOTALY" v-model="formTypeData.type_under_stock" id="flexCheckDefault4" />
                <label class="form-check-label fs-3 fw-bold" for="flexCheckDefault4">
                    {{$t('absences.setting.totaly')}}
                </label>
              </div>
              <span class="fs-3 text-muted" v-html="$t('absences.setting.totaly_text')"></span>
            </div>
            <div class="col-12 col-md-4 col-lg-4">
              <div class="form-check mb-5">
                <input class="form-check-input mt-1" type="radio" value="BOTH" v-model="formTypeData.type_under_stock" id="flexCheckDefault4" />
                <label class="form-check-label fs-3 fw-bold">
                    {{$t('absences.setting.both')}}
                </label>
              </div>
              <span class="fs-3 text-muted" v-html="$t('absences.setting.both_text')"></span>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #cardFooter>
      <div class="d-flex justify-content-end">
        <Button btn-class="btn-sm me-3" type="submit" @click="submitDataForm" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingType"></Button>
      </div>
    </template>
  </Card>

  <CreateHolidayTypeModal id="holiday_type_create" @load="setHolidayType"/>
</template>

<script setup>
import {computed, nextTick, onMounted, ref, watch, defineEmits, defineProps} from "vue";
import Card from "@/Modules/Financial/components/Card.vue";
import Button from "@/components/Button.vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import abilities from "@/composables/abilities";
import {Theme} from "@/composables/theming";
import {useSwal} from "@/composables/useSwal";
import { useI18n } from 'vue-i18n'
import {useRouter, useRoute} from 'vue-router';
import VueNumberFormat from 'vue-number-format'
import Select2 from "@/components/Select2.vue";
import { ColorPicker } from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import CreateHolidayTypeModal from "@/Modules/RH/views/Setting/components/Modals/CreateHolidayTypeModal";

const store = useStore()
const router = useRouter()
const route = useRoute()
const { can } = useHasAbility()
const {showSwal} = useSwal()
const { t } = useI18n({ useScope: 'global' })

const {locale, datatableLocaleUrl} = useLocales()

const formTypeData = ref({
  id: '',
  holiday_type_id: '',
  paid: false,
  attachment: false,
  society_id: '',
  include_day_off: false,
  stock: 0,
  seniority: false,
  min_seniority: 0,
  type_under_stock: 'PARTIALLY',
  description: '',
  color: '#000',
  periode: 'days',
  reinitialable: false,
  allow_previous_date: false,
  take_all_without_count: false,
  cummulable: 'fixed',
  cummulabe_periode: 'months',
  stock_periode: 'days',
  have_stock: false
})
const isLoadingType = ref(false)
const absenceTypeConfig = ref({})

const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])
const absenceTypes = computed(() => store.getters['absence_types/getAbsenceTypes'])

watch(() => currentSociety.value, (value) => {
  if(value){
    formTypeData.value.society_id = value?.id
  }
}, { deep: true })

watch(() => route.params.id, (value) => {
  getAbsenceTypeConfig()
})

function submitDataForm(){
  isLoadingType.value = true
  store.dispatch('absence_types/setAbsenceTypeConfig', formTypeData.value)
      .then((response) => {
          isLoadingType.value = false
          router.push({name: 'settings-leaves'})

          window.toastr['success'](i18n.global.t('absences.setting.absence_types_config_successfully'))
      })
      .catch(err => {
          isLoadingType.value = false
      })
}

async function getAbsenceTypeConfig(){
  if(route.params.id && route.name == 'settings-leave-update' && currentSociety.value){
    await store.dispatch('absence_types/getAbsenceTypeConfig', {id: route.params.id, country: currentSociety.value?.country_id})
      .then((response) => {
        if(response.data) {
          absenceTypeConfig.value = response.data?.holiday_type_management

          formTypeData.value = {
            id: absenceTypeConfig.value.id,
            holiday_type_id: absenceTypeConfig.value.holiday_type_id,
            paid: absenceTypeConfig.value.paid,
            attachment: absenceTypeConfig.value.attachment,
            society_id: absenceTypeConfig.value.society_id,
            include_day_off: absenceTypeConfig.value.include_day_off,
            stock: absenceTypeConfig.value.stock,
            seniority: absenceTypeConfig.value.seniority,
            min_seniority: absenceTypeConfig.value.min_seniority,
            type_under_stock: absenceTypeConfig.value.type_under_stock,
            description: absenceTypeConfig.value.description,
            color: absenceTypeConfig.value.color,
            periode: absenceTypeConfig.value.periode,
            reinitialable: absenceTypeConfig.value.reinitialable,
            allow_previous_date: absenceTypeConfig.value.allow_previous_date,
            take_all_without_count: absenceTypeConfig.value.take_all_without_count,
            cummulable: absenceTypeConfig.value.cummulable || 'fixed',
            cummulabe_periode: absenceTypeConfig.value.cummulabe_periode,
            stock_periode: absenceTypeConfig.value.stock_periode,
            have_stock: absenceTypeConfig.value.have_stock,
          }
        }
      })
  }
}

function openCreateModal(){
  $('#holiday_type_create').modal('toggle')
}

function setHolidayType(id){
  formTypeData.value.holiday_type_id = id
}

function loadType() {
  store.dispatch('absence_types/loadAbsenceTypes') 
}

onMounted(async() => {
  store.dispatch('offices/loadOfficesBySocieties') 
  loadType() 
  getAbsenceTypeConfig()
})
</script>

<style scoped>

  .end-3 {
    right: 1rem;
  }

</style>